export const getDollars = (amount = NaN) => {
  return amount.toFixed(2);
};

export const getCents = (amount = NaN) => {
  return +amount.toString().split('.')[1];
};

export const getSampleAttributeValues = ({ specificationGroup, attributes }) => {
  const attributeValues = [];
  // match the sample attribute value with the attribute value from the parent
  attributes.forEach((attr) => {
    specificationGroup.forEach((specGroup) => {
      const { specifications } = specGroup;
      if (specifications.some(({ specName }) => specName === attr.attributeName)) {
        attributeValues.push(specifications.find(({ specName }) => specName === attr.attributeName).specValue);
      }
    });
  });

  return attributeValues.length ? attributeValues.reduce((acc, curr) => `${acc}, ${curr}`) : null;
};
